import {Component, Inject, OnInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {SubcategoryService} from 'src/app/services/subcategory.service';

@Component({
  selector: 'app-criteria-dialog',
  templateUrl: './criteria-dialog.component.html',
  styleUrls: [ './criteria-dialog.component.scss' ]
})
export class CriteriaDialogComponent implements OnInit {

  public array: any[] = [];
  public situationArray: any[] = [];
  public defaultArray: any[] = [];

  constructor (
    private _categoryService: SubcategoryService,
    public matDialogRef: MatDialogRef<CriteriaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
   // console.log("this.data: " + JSON.stringify(this.data))
    switch (this.data.name) {

      case "Categoria":
        this.loadCategory();
        break;

      case "Situação":
        this.loadSituations()
        break;

      default:
        this.loadDefaults()
        break;
    }

  }

  ngOnInit () {

  }

  loadCategory () {

    this._categoryService.select()
      .subscribe((result) => {
        this.array.push({'name': 'Todos', 'id': '99', 'selected': false})
        result.forEach(item => {
          this.array.push({
            'name': item.payload.doc.data().name,
            'id': item.payload.doc.id,
            'selected': false
          })
        })
        this.markSelected()
      })
  }

  loadSituations () {
    this.array.push({'name': 'Todos', 'id': '99', 'selected': false})
    this.array.push({'name': 'Quite', 'id': '0', 'selected': false})
    this.array.push({'name': 'Não-Quite', 'id': '1', 'selected': false})
    this.array.push({'name': 'Isento', 'id': '2', 'selected': false})

    this.markSelected()
  }

  loadDefaults () {
    this.array.push({'name': 'Todos', 'id': '99', 'selected': false})
    this.array.push({'name': 'Preenchido', 'id': '0', 'selected': false})
    this.array.push({'name': 'Vazio', 'id': '1', 'selected': false})

    this.markSelected()
  }


  markSelected () {
    if (!this.data.criteria)
      this.data.criteria = []

    this.array.forEach((item) => {
      let mark = this.data.criteria.find((e) => {
        return e.id == item.id
      })
      if (mark) {
        item.selected = true;
      } else {
        item.selected = false
      }
    })
  }

  markCheck (item) {
    //.log(JSON.stringify(item))
    if (item.id == '99') {
      this.array.forEach(element => {
        if (element.id != '99') {
          element.selected = false
        }
      });
    } else {
      let i = this.array.find((e) => {
        return e.id == '99'
      })
      i.selected = false;
    }

  }
}
